import http from '@/utils/http';

const baseUrl = '/rastreabilidade/produto';

export default {
    getProducts() {
        return http.get({
            url: `${baseUrl}/listar`,
            lockScreen: false
        });
    }
};
